import React, { useState, useEffect } from "react";
import { db } from "../../../../assets/firebase/firebaseconfig";
import { ref, get, remove, update, onValue } from "firebase/database";
import "../ProductManager/styles.css";
const UserManager = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");

  const [formData, setFormData] = useState({
    username: "",
    phone: "",
    password: "",
    role: "",
  });

  useEffect(() => {
    const userRef = ref(db, "users");
    onValue(userRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setUsers(list);
      } else {
        setUsers([]);
      }
    });
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await update(ref(db, `users/${editingUser.id}`), formData);
      alert("Cập nhật thông tin thành công!");
      closeModal();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setShowEditModal(false);
    setEditingUser(null);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Bạn có chắc chắn muốn xóa người dùng này?")) {
      await remove(ref(db, `users/${id}`));
    }
  };

  const filteredUsers = users
    .filter(
      (u) =>
        (u.username?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
        (u.phone || "").includes(searchTerm)
    )
    .sort((a, b) => {
      return sortOrder === "asc"
        ? a.username.localeCompare(b.username)
        : b.username.localeCompare(a.username);
    });

  return (
    <div className="admin-content-inner">
      <div className="page-header">
        <h1>QUẢN LÝ THÀNH VIÊN</h1>
      </div>

      <div className="filter-section card">
        <div className="filter-bar-container">
          <div className="search-box">
            <input
              type="text"
              placeholder="Tìm tên hoặc số điện thoại..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="sort-box">
            <select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              className="sort-select"
            >
              <option value="asc">Sắp xếp: Tên A-Z</option>
              <option value="desc">Sắp xếp: Tên Z-A</option>
            </select>
          </div>

          {}
        </div>
      </div>

      <div className="table-section card">
        <table className="main-table">
          <thead>
            <tr>
              <th>TÊN ĐĂNG NHẬP</th>
              <th>SỐ ĐIỆN THOẠI</th>
              <th>MẬT KHẨU</th>
              <th>QUYỀN HẠN</th>
              <th>THAO TÁC</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((item) => (
              <tr key={item.id}>
                <td>
                  <strong>{item.username}</strong>
                </td>
                <td>{item.phone}</td>
                <td>
                  <code>{item.password}</code>
                </td>
                <td>
                  <span className={`role-tag ${item.role?.toLowerCase()}`}>
                    {item.role || "User"}
                  </span>
                </td>
                <td>
                  <div className="action-btns">
                    <button
                      className="btn-edit-tool"
                      onClick={() => {
                        setEditingUser(item);
                        setFormData(item);
                        setShowEditModal(true);
                      }}
                    >
                      Sửa
                    </button>
                    <button
                      className="btn-delete-tool"
                      onClick={() => handleDelete(item.id)}
                    >
                      Xóa
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {}
      {showEditModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>CHỈNH SỬA THÔNG TIN</h3>
              <button className="btn-close" onClick={closeModal}>
                &times;
              </button>
            </div>
            <form onSubmit={handleUpdate}>
              <div className="form-group">
                <label>Tên đăng nhập:</label>
                <input
                  type="text"
                  value={formData.username}
                  onChange={(e) =>
                    setFormData({ ...formData, username: e.target.value })
                  }
                  required
                />
              </div>
              <div className="form-group">
                <label>Số điện thoại:</label>
                <input
                  type="text"
                  value={formData.phone}
                  onChange={(e) =>
                    setFormData({ ...formData, phone: e.target.value })
                  }
                  required
                />
              </div>
              <div className="form-group">
                <label>Mật khẩu mới:</label>
                <input
                  type="text"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                  required
                />
              </div>
              <div className="form-group">
                <label>Phân quyền:</label>
                <select
                  value={formData.role}
                  onChange={(e) =>
                    setFormData({ ...formData, role: e.target.value })
                  }
                >
                  <option value="Admin">Quản trị viên</option>
                  <option value="Staff">Nhân viên</option>
                  <option value="User">Khách hàng</option>
                </select>
              </div>
              <button
                type="submit"
                disabled={loading}
                className="btn-submit-form"
              >
                {loading ? "Đang lưu..." : "CẬP NHẬT NGAY"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserManager;
